import React, { Component } from 'react'
import styled from "styled-components";
import { withTranslation } from 'react-i18next';
import { Mobile, Desktop } from '../../../media'
import { Wrapper, Button } from 'react-aria-menubutton';
import ReactDOM from 'react-dom';
import BubbleMenu from '../../BubbleMenu';

import HorizontalEllipsisIcon from '../../../images/ellipsis-h.svg'
import HorizontalEllipsisSelectedIcon from '../../../images/ellipsis-h-selected.svg'
import VerticalEllipsisIcon from '../../../images/ellipsis-v.svg'
import VerticalEllipsisSelectedIcon from '../../../images/ellipsis-v-selected.svg'
import ChevronImage from '../../../images/chevron_green.svg'
import ChevronImageUp from '../../../images/chevron_green_up.svg'

const Container = styled.ul`
    display: table;
    border-collapse: collapse;
    width: 960px;
    margin: 0 auto;
    padding: 0;
    list-style-type: none;

    // Mobile version.
    @media (max-width: 768px) {
        width: 100%;
        margin: 0;
        display: block;
    } 

    .accept-award-link {
        cursor: pointer;
    }
`

const InfoRow = styled.li`

    display: table-row;
    height: 78px;
    border-top: 1px solid #CCCCCC;
    border-bottom: 1px solid #CCCCCC;

    // Mobile version.
    @media (max-width: 768px) {
      display: block;
      height: auto;
      padding-bottom: 20px;
    }

    &:first-child {
        border-top: none;
    }

    > div.info {
        > h3[aria-expanded=true] {
            > span.award-vest-chevron {
                background-image: url(${ChevronImageUp});
            }
        }
    }

    > div.info {
        display: table-cell;
        padding-left: 15px;
        padding-top: 15px;
        padding-bottom: 9px;
        vertical-align: top;
        cursor: pointer;

        // Mobile version.
        @media (max-width: 768px) {
            display: block;
            width: auto;
            padding-right: 15px;
        }

        > h3[role=button] {
            vertical-align: bottom;
            margin-top: 15px;
            padding: 0;
            margin: 0;

            > span {
                border: 0;
                background-color: white;
                background-image: url(${ChevronImage});
                background-repeat: no-repeat;
                background-position: left center;
                padding-left: 30px;
                color: #4d4d4d;
                font-family: Lato-Light;
                font-size: 18px;
                font-weight: normal;
                line-height: 25px;

                // Mobile version.
                @media (max-width: 768px) {
                    display: block;
                }
            }

            > span.tooltip-area {
                vertical-align: bottom
            }

            > div.tooltip-area {
                display: inline-block;
                position: relative;
                margin-left: 10px;
                vertical-align: top;

                @media (max-width: 768px) {
                    margin-left: 0;
                    margin-right: 10px;
                }

                span[role=button] {
                    width: auto;
                    height: 25px;
                    background: #303042;
                    border-radius: 100px;
                    padding: 4px 10px;
                    border: none;

                    font-family: Lato-Regular;
                    font-size: 12px;
                    font-weight: normal;

                    color: #FFFFFF;
                    line-height: 16px;
                    cursor: pointer;
                }

                div[role=menu] {
                    width: 160px;
                    height: auto;

                    > ul > li {
                        padding: 5px 9px;
                        line-height: 0.5;

                        > a {
                            font-family: Lato-Regular;
                            font-size: 12px;
                            color: #666666;
                            line-height: 16px;
                        }
                    }
                }
            }
        }

        > p {
            font-family: Lato-Regular;
            font-size: 14px;
            color: #2B2B2B;
            line-height: 22px;
            padding: 0;
            margin: 5px 0 0 0;
        }
    }

    > div.info > h3 > div.menu-button {
        display: inline-block;
        float: right;
        width: 42px;
        height: 20px;

        span[role=button] {
            border: 1px solid #BABABA;
            border-radius: 10px;
            margin-top: 0;
            width: 42px;
            height: 20px;
            background-image: url(${HorizontalEllipsisIcon});
        }

        span[role=button]:hover {
            background-color: #e5f8ed;
        }

        span[role=button]:active, span[role=button][aria-expanded=true] {
            background-color: #00B550;
            border-left-color: #00B550;
            background-image: url(${HorizontalEllipsisSelectedIcon});
        }

        div[role=menu] {
            width: 251px;
        }
    }

    div.menu-button {
        display: table-cell;
        width: 24px;
        position: relative;
        cursor: pointer;

        div[role=menu] {
            width: 342px;
            height: auto;
        }

        span[role=button] {
            display: block;
            margin-top: 5px;
            border-left: 1px solid #DDDDDD;
            background-image: url(${VerticalEllipsisIcon});
            background-repeat: no-repeat;
            background-position: center; 
            width: 24px;
            height: 68px;
        }

        span[role=button]:hover {
            background-color: #e5f8ed;
        }

        span[role=button]:active, span[role=button][aria-expanded=true] {
            background-color: #00B550;
            border-left-color: #00B550;
            background-image: url(${VerticalEllipsisSelectedIcon});
        }
    }
`

class RowInfo extends Component {

    componentDidMount() {
        const domNode = ReactDOM.findDOMNode(this);
        var rowInfo = domNode.querySelectorAll('h3.info[aria-expanded][aria-controls]');
        var buttonExpand = new window.ButtonExpand(rowInfo[0]);
        buttonExpand.init();

        var awardLink = domNode.querySelectorAll('button.accept-award-link');
        if( awardLink != null && awardLink.length > 0 ) {
            awardLink[0].addEventListener('click', this.onAcceptAwardClick);
        }
    }

    onSelectMenuItem = (value) => {
        if(this.props.onSelectMenuItem){
            this.props.onSelectMenuItem(value)
        }
    }

    onAcceptAwardClick = (event) => {
        event.stopPropagation();

        if(this.props.onAcceptAward){
            this.props.onAcceptAward(event)
        }
    }

    renderAcceptedLabel() {
        if (this.props.isAwardAccepted) {
            return <span>({this.props.acceptedLabel})</span>;
        } else {
            return <button tabIndex={0} className="accept-award-link" >{this.props.acceptedLabel}</button>;
        }
    }

    render() {

        return (
            <Container>
                <InfoRow>
                    <div className="info">
                        <h3 role="button" tabIndex={0} className="info" aria-expanded={false} aria-controls={this.props.rowId}>
                            <span className="award-vest-chevron">
                                <span className="title">{this.props.title}</span>
                            </span>

                            {this.props.badgeLabel && this.props.badgeText &&
                                <Wrapper className="tooltip-area">
                                    <Button>{this.props.badgeLabel}</Button>
                                    <BubbleMenu arrow="up" options={[{value: 0, label: this.props.badgeText}]}/>
                                </Wrapper>
                            }

                            {this.props.badgeLabel2 && this.props.badgeText2 &&
                                <Wrapper className="tooltip-area">
                                    <Button>{this.props.badgeLabel2}</Button>
                                    <BubbleMenu arrow="up" options={[{value: 0, label: this.props.badgeText2}]}/>
                                </Wrapper>
                            }

                            <Mobile>
                                <Wrapper className="menu-button" onSelection={this.onSelectMenuItem.bind(this)}>
                                    <Button aria-label={this.props.menuLabel}>&nbsp;</Button>
                                    <BubbleMenu arrow="left" options={this.props.menuOptions}/>
                                </Wrapper>
                            </Mobile>
                        </h3>
                        <p>{this.props.text} {this.props.acceptedLabel && this.renderAcceptedLabel()}</p>
                    </div>

                    {this.props.children}

                    <Desktop>
                        <Wrapper className="menu-button" onSelection={this.onSelectMenuItem.bind(this)}>
                            <Button aria-label={this.props.menuLabel} >&nbsp;</Button>
                            <BubbleMenu arrow="left" options={this.props.menuOptions}/>
                        </Wrapper>
                    </Desktop>

                </InfoRow>
            </Container>
        )
    }
}

export default (withTranslation("translations")(RowInfo));
